module.exports = __webpack_public_path__ + "static/media/CTLA_10-356w.43af57b4.jpg";